export const MERGE = 'entities/MERGE';
export const SYNC = 'entities/SYNC';
export const UPDATE = 'entities/UPDATE';
export const REMOVE = 'entities/REMOVE';